import { Maybe, UserVerification } from '@adc/sdk/types'
import * as graph from '@adc/sdk'
const { VerificationStatus } = graph.enums

export const errorCodeCopyMap: Record<string, string> = {
  '100': 'This ID has been compromised. Please try again.',
  '102': 'This is a black & white photo. Please upload a color photo instead.',
  '103': 'Please take a clear color photo and resubmit.',
  '104':
    'Please upload a photo of a physical ID. We do not accept photos of digital IDs.',
  '105': 'This ID is invalid. Please upload a different ID.',
  '106': 'This ID is invalid. Please upload a different ID.',
  // 107 & 108 not applicable (banking related)
  '109': 'This ID is no longer valid. Please upload a valid ID.',
  '110': 'Your ePassport and physical passport do not match. Please try again.',
  '111': 'The data from this ID and your physical ID do not match.',
  '200': 'This ID is not readable. Please upload a clear photo of your ID.',
  '201': 'This is not a valid ID. Please upload a valid ID.',
  '202': 'This is a sample ID. Please upload a legal ID.',
  '206': 'A photo of the back of your ID is missing. Please upload now.',
  '207': 'This ID is missing important information. Please try again.',
  '209': 'This ID is missing your signature. Please try again.',
  '210':
    'This device captured a photo in Black & White. Please adjust to color settings.',
  '211':
    'The front and back of this ID show different people. Please try again.',
  '300': 'This is not a valid ID. Please try again.',
  '2001':
    'This photo of your ID is blurred. Please upload a clear photo of your ID.',
  '2002':
    'The quality of this ID is not acceptable. Please upload a better photo of your ID.',
  '2003': 'This ID is missing important data. Please upload a different ID.',
  '2004': 'Parts of your ID are covered. Please adjust and re-upload your ID.',
  '2005': 'This ID is damaged. Please upload a better-quality ID.',
}

/**
 * Checks if the verification process can be initialized.
 * @param verificationStatus - The current user verification status.
 * @returns {boolean} - Returns true if the verification can be initialized, false otherwise.
 */
export const canInitializeVerification = (
  verificationStatus?: Maybe<UserVerification>
) =>
  !verificationStatus?.internal_verification_status ||
  [VerificationStatus.NotVerified, VerificationStatus.RejectedOther].includes(
    verificationStatus?.internal_verification_status
  )
